if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      saveAddedToCartProductToLocalStorage() {
        const key = '__recently_added_products';
        const dataDom = this.querySelector('script[product-added-cart-data]');
        if (!dataDom) {
          console.warn('No product-added-cart-data script tag found.');
          return
        }
        const productDataString = this.querySelector('script[product-added-cart-data]').textContent;
        const productData = JSON.parse(productDataString);
        let recentlyAddedProducts = JSON.parse(localStorage.getItem(key)) || [];

        const productIndex = recentlyAddedProducts.findIndex(item => item.id === productData.id);
        if (productIndex !== -1) {
          recentlyAddedProducts.splice(productIndex, 1);
        }
        recentlyAddedProducts.unshift(productData);
        localStorage.setItem(key, JSON.stringify(recentlyAddedProducts));
      }

      getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
      }

      hasCrossSell() {
        const isThisAtPdpMainInfoSection = this.closest('.product .product__info-wrapper');
        if (!isThisAtPdpMainInfoSection) return false;

        const crossSellDom = isThisAtPdpMainInfoSection.querySelector('.pdp-cross-sell-products input[type=checkbox]:checked');

        if (!crossSellDom) return false;

        return true;
      }

      addMultiplydProductsToCart() {
        const selectedCrossSellProductsDom = document.querySelectorAll('.product__info-wrapper .pdp-cross-sell-products input[type=checkbox]:checked');
        if (!selectedCrossSellProductsDom || selectedCrossSellProductsDom.length === 0) return;

        const selectedCrossSellProducts = []
        selectedCrossSellProductsDom.forEach(checkbox => {
          selectedCrossSellProducts.push({
            id: parseInt(checkbox.getAttribute('data-selected-variant-id')),
            quantity: 1
          });
        });
        const mainProductVariantId = parseInt(this.variantIdInput.value);
        const mainProductQuantity = this.form.querySelector('select[name="quantity"]') ? parseInt(this.form.querySelector('select[name="quantity"]').value) || 1 : 1;
        selectedCrossSellProducts.push({
          id: mainProductVariantId,
          quantity: mainProductQuantity
        });
        console.log('Adding multiple products to cart:', selectedCrossSellProducts);
        console.log('Adding main product to cart:', mainProductVariantId);
        // add attributes[mor_store_code]
        const storeCode = this.getCookie('mor_store_code');
        selectedCrossSellProducts.forEach(product => {
          product.attributes = {
            'mor_store_code': storeCode
          };
        });
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: selectedCrossSellProducts,
            sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [],
            sections_url: this.cart ? window.location.pathname : undefined,
          })
        })
        .then(response => {
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form-multiple',
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers-multiple');
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form-multiple',
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers-multiple', startMarker);
            });
          this.error = false;
          
          CartPerformance.measure("add:paint-updated-sections-multiple", () => {
            this.cart.renderContents(response);
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if(this.hasCrossSell()) {
          this.addMultiplydProductsToCart();
          return
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const storeCode = this.getCookie('mor_store_code');
        if (storeCode) {
          formData.append('attributes[mor_store_code]', storeCode);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const quickviewModal = this.closest('quickview-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (quickviewModal) {
              const closeBtn = quickviewModal.querySelector('[data-drawer-close]');
              if (closeBtn) closeBtn.click();
              setTimeout(() => {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              }, 300);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);

            this.saveAddedToCartProductToLocalStorage()
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const scrollToBarSubmitButton = document.querySelector('scroll-to-bar [type="submit"]');
        if (disable) {
          if (this.closest('.shop_best-product')) {
            const swiper = this.closest('shop-best-section-swiper, common-swiper');
            const slide = this.closest('.swiper-slide');
            if (swiper && typeof swiper.removeSlide === 'function') {
              swiper.removeSlide(slide);
            } else {
              slide.remove();
            }
          }
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          if(scrollToBarSubmitButton) {
            scrollToBarSubmitButton.setAttribute('disabled', 'disabled');
            scrollToBarSubmitButton.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          if(scrollToBarSubmitButton) {
            scrollToBarSubmitButton.removeAttribute('disabled');
            scrollToBarSubmitButton.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get('product-stock')) {
  customElements.define('product-stock', class extends HTMLElement {
    constructor() {
      super();
      this.storeCode = document.querySelector('header-zipcode-locator')?.getCurrentStoreCode();
      this.inStockDom = this.querySelector('.in-stock');
      this.outOfStockDom = this.querySelector('.out-of-stock');
      this.webInvMessage = '';

      this.stockStatus = true
    }

    getLocationInfo() {
      const locationInfoDom = this.querySelector('script[type="application/json"]');
      if (!locationInfoDom) {
        this.locationInfo = {}

        return
      }
      this.locationInfoString = locationInfoDom.textContent.trim();
      try {
        this.locationInfo = JSON.parse(this.locationInfoString)
      } catch (e) {
        this.locationInfo = {}
      }
    }

    getCurrentStoreStockStatus() {
      if (!this.storeCode) return null;
      if (!this.locationInfo) return false;

      const locationData = this.locationInfo[this.storeCode];
      if (!locationData) return false;
      this.webInvMessage = locationData.webInvMessage || '';
      
      return locationData.regionallyAvailable === 'Y';
    }

    connectedCallback() {
      this.getLocationInfo();
      this.stockStatus = this.getCurrentStoreStockStatus();
      this.updateStockStatus();
    }

    updateStockStatus() {
      if (this.stockStatus === null) {
        if (this.inStockDom && this.outOfStockDom) {
          this.inStockDom.style.display = 'none';
          this.outOfStockDom.style.display = 'none';
        }
        this.dataset.stock = '';
        return;
      }

      this.dataset.stock = this.stockStatus ? 'Y' : 'N';
      if (this.inStockDom && this.outOfStockDom) {
        this.inStockDom.innerHTML = this.stockStatus ? this.webInvMessage : 'In stock and ready to ship!';

        const matchedMessage = this.webInvMessage.match('Estimated Product Availability in');
        if (this.stockStatus && matchedMessage) {
          this.classList.add('estimated-availability');
        } else {
          this.classList.remove('estimated-availability');
        }
        this.inStockDom.style.display = this.stockStatus  ? 'block' : 'none';
        this.outOfStockDom.style.display = !this.stockStatus ? 'block' : 'none';
      }

      if (this.productForm && this.productForm.toggleSubmitButton) {
        this.productForm?.toggleSubmitButton(!this.stockStatus, window.variantStrings.soldOut);
      } else {
        console.warn('No product form found for product stock component to toggle submit button state.');
      }
    }

    get productForm() {
      return this.closest('product-form') || this.closest('.product__info-container')?.querySelector(`product-form`);
    }
  });
}
